function s(n) {
  return n != null && typeof n.valueOf() == "string";
}
function e(n) {
  return n != null && typeof n.valueOf() == "number";
}
function o(n) {
  return n != null && typeof n.valueOf() == "boolean";
}
const t = (n) => y(n) || f(n), w = (n) => n.type === "functioncall" && Object.prototype.hasOwnProperty.call(n, "name") && s(n.name) && Object.prototype.hasOwnProperty.call(n, "args") && Array.isArray(n.args) && n.args.every((r) => t(r)), f = (n) => s(n) || e(n) || o(n) || n === null, b = (n) => !!((n?.min || n?.max) && (!n.min || i(n.min) || e(n.min)) && (!n.max || i(n.max) || e(n.max))), q = (n) => l(n) || c(n) || m(n), l = (n) => ["==", "*=", "!=", "<", "<=", ">", ">=", "<=x<="].includes(n), c = (n) => ["&&", "||"].includes(n), m = (n) => n === "!", u = (n) => d(n) || S(n) || a(n) || h(n) || a(n) || o(n), d = (n) => {
  const r = n && n[0] === "<=x<=" ? 4 : 3;
  return Array.isArray(n) && n.length === r && l(n[0]) && t(n[1]) && t(n[2]) && (n[0] !== "<=x<=" || e(n[3]));
}, S = (n) => Array.isArray(n) && n.length >= 3 && c(n[0]) && n.every((r, p) => p === 0 || u(r)), h = (n) => Array.isArray(n) && n.length === 2 && m(n[0]) && u(n[1]), x = (n) => C(n) || N(n) || F(n) || v(n), C = (n) => O(n) || A(n) || T(n), O = (n) => n?.kind === "Icon", T = (n) => n?.kind === "Text", A = (n) => n?.kind === "Mark" && s(n?.wellKnownName), N = (n) => n?.kind === "Line", F = (n) => n?.kind === "Fill", v = (n) => n?.kind === "Raster", E = (n) => !!(s(n?.name) && (!n?.filter || u(n.filter)) && (!n?.scaleDenominator || b(n.scaleDenominator)) && n?.symbolizers?.every((r) => x(r))), G = (n) => n?.redChannel !== void 0 || n?.greenChannel !== void 0 || n?.blueChannel !== void 0, I = (n) => n?.grayChannel !== void 0, i = (n) => [
  "abs",
  "acos",
  "add",
  "asin",
  "atan",
  "atan2",
  "ceil",
  "cos",
  "div",
  "exp",
  "floor",
  "interpolate",
  "log",
  "max",
  "min",
  "modulo",
  "mul",
  "pi",
  "pow",
  "random",
  "rint",
  "round",
  "sin",
  "sqrt",
  "strIndexOf",
  "strLastIndexOf",
  "strLength",
  "sub",
  "tan",
  "toDegrees",
  "toNumber",
  "toRadians"
].includes(n?.name), z = (n) => [
  "numberFormat",
  "strAbbreviate",
  "strCapitalize",
  "strConcat",
  "strDefaultIfBlank",
  "strReplace",
  "strStripAccents",
  "strSubstring",
  "strSubstringStart",
  "strToLowerCase",
  "strToString",
  "strToUpperCase",
  "strTrim"
].includes(n?.name), a = (n) => [
  "all",
  "any",
  "between",
  "double2bool",
  "equalTo",
  "greaterThan",
  "greaterThanOrEqualTo",
  "in",
  "lessThan",
  "lessThanOrEqualTo",
  "not",
  "notEqualTo",
  "parseBoolean",
  "strEndsWith",
  "strEqualsIgnoreCase",
  "strMatches",
  "strStartsWith"
].includes(n?.name), k = (n) => [
  "case",
  "property",
  "step"
].includes(n?.name), y = (n) => a(n) || i(n) || z(n) || k(n), L = (n) => typeof n?.source == "string" || y(n?.source) && Array.isArray(n.position) && Array.isArray(n.size);
export {
  S as isCombinationFilter,
  c as isCombinationOperator,
  d as isComparisonFilter,
  l as isComparisonOperator,
  t as isExpression,
  F as isFillSymbolizer,
  u as isFilter,
  w as isFunctionCall,
  a as isGeoStylerBooleanFunction,
  y as isGeoStylerFunction,
  i as isGeoStylerNumberFunction,
  z as isGeoStylerStringFunction,
  k as isGeoStylerUnknownFunction,
  I as isGrayChannel,
  O as isIconSymbolizer,
  N as isLineSymbolizer,
  A as isMarkSymbolizer,
  h as isNegationFilter,
  m as isNegationOperator,
  q as isOperator,
  C as isPointSymbolizer,
  f as isPropertyType,
  v as isRasterSymbolizer,
  G as isRgbChannel,
  E as isRule,
  b as isScaleDenominator,
  L as isSprite,
  x as isSymbolizer,
  T as isTextSymbolizer
};
//# sourceMappingURL=typeguards.js.map
